import { userInfoSync } from 'hub-http/userInfo';
import enviro from 'enviro';
import Raven from 'raven-js';
export const hasScope = scopeName => {
  try {
    const userInfo = userInfoSync();
    const {
      scopes
    } = (userInfo === null || userInfo === void 0 ? void 0 : userInfo.user) || {
      scopes: []
    };
    return scopes.includes(scopeName);
  } catch (err) {
    if (enviro.isQa()) {
      console.error(err);
    }
    Raven.captureException(err, {
      extra: {
        message: 'Error getting user info from `userInfoSync`'
      }
    });
  }
  return false;
};